import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CarouselComp from '../../components/carousel';
import { getCarousel } from '../../slices/carouselSlice';
import LoaderCP from '../../components/loader';

const CarouselContainer = () => {
  const dispatch = useDispatch();
  const { carousel, status } = useSelector((state) => state.carousel);

  useEffect(() => {
    dispatch(getCarousel());
  }, []);

  return (
    <div>
      {status === 'loading' ? <LoaderCP /> : ''}
      {status === 'failed' ? '' : ''}
      {status === 'success' && carousel.length > 0
        ? <CarouselComp items={carousel} />
        : '' }
    </div>
  );
};

export default CarouselContainer;
